export function RohitLoharMark(props: React.ComponentProps<"svg">) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 100 50"
            {...props}
        >
            <text
                x="50"
                y="35"
                textAnchor="middle"
                fill="currentColor"
                fontSize="24"
                fontWeight="bold"
                fontFamily="var(--font-samakaran), system-ui, sans-serif"
            >
                RL
            </text>
        </svg>
    );
}

export function getMarkSVG(color: string) {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 50"><text x="50" y="35" text-anchor="middle" fill="${color}" font-size="24" font-weight="bold" font-family="var(--font-samakaran), system-ui, sans-serif">RL</text></svg>`;
}
